<template>
  <v-card>
    <v-card-title>
      Mass Edit Items
      <div class="flex-grow-1"></div>
      <v-btn text @click="$emit('editMode')" :disabled="selectedItems.length < 1">Edit</v-btn>
      <v-btn text class="ml-3" @click="$emit('clearTable'); selectedItems=[]" :disabled="propScannedItems.length < 1">Clear</v-btn>
    </v-card-title>
    <v-card-title>
      <div class="flex-grow-1"></div>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Filter"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-card-text>
        <v-data-table
          v-if="propScannedItems"
          v-model="selectedItems"
          :headers="headers"
          :items="propScannedItems"
          :search="search"
          show-select
          item-key="id"
          class="elevation-1">
        </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'MassEditItemsTable',

  props: ['propScannedItems'],

  data: () => ({
    search: '',
    selectedItems: [],
    headers: [
      { text: 'Serial Number', value: 'serialNumber' },
      { text: 'Casing ID', value: 'casingId' },
      { text: 'IMSI', value: 'imsi' },
      { text: 'ICCID', value: 'iccid' },
      { text: 'Box PN', value: 'boxPn' },
      { text: 'Box ID', value: 'boxId' }
    ]
  }),

  watch: {
    selectedItems (value) {
      this.$emit('selectedItems', value)
    }
  }
}
</script>
